import { createRouter, createWebHistory } from 'vue-router'
import permission   from '@/helpers/permissions'
import crypto       from '@/helpers/crypto'
// Views
import ResetPassword from '@/views/Auth/ResetPassword'
import EpayPayment   from '@/views/Payment/EpayPayment'
import Instruction   from '@/views/Instruction'
import Termination   from '@/views/Functional/Termination'
import Rewrite       from '@/views/Functional/Rewrite'
import Terminals     from '@/views/Accountant/Terminals'
import Branches      from '@/views/Branches'
import Policies      from '@/views/Policies'
import Drafts        from '@/views/Drafts'
import Login         from '@/views/Auth/Login'
import Index         from '@/views/Index'
import Podft         from '@/views/Podft'
import Ogpo          from '@/views/Products/Ogpo'
import BpmOgpo       from '@/views/Products/Bpm/BpmOgpo'
import BpmOsgpoModule from '@/helpers/Modules/Product/BpmOsgpoModule'
// Profile
import Profile       from '@/views/Profile/Profile'
import AVR           from '@/views/Profile/AVR'
// Admin
import Products      from '@/views/Admin/Products'
import Versions      from '@/views/Admin/Versions'
import Agreement     from '@/views/Admin/Agreement/Agreement'
import Dashboard     from '@/views/Admin/Dashboard'
// Layout
import ProfileLayout from '@/views/Layout/ProfileLayout'
import PageNotFound  from '@/views/PageNotFound'
import MainLayout    from '@/views/Layout/MainLayout'
import AuthLayout    from '@/views/Layout/AuthLayout'
// Financial Institutions
import Properties    from '@/views/Products/FinancialInstitutions/Properties'
import Casco         from '@/views/Products/FinancialInstitutions/Casco'
// Support
import OperatorError from '@/views/Support/OperatorError'
// Public
import KdpAgree           from '@/views/Public/KDP/KdpAgree'
import FunctionalOTPAgree from "@/views/Public/Functional/FunctionalOTPAgree.vue";

const routes = [
  //   Main
  {
    path: '',
    redirect: { name: 'Index'},
    component: MainLayout,
    children: [
      {
        path: '/',
        name: 'Index',
        component: Index,
        meta: {
          requiresAuth: true,
          title: 'Главная',
          roles: permission.all()
        }
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true,
          title: 'Информация',
          roles: permission.admin()
        }
      },
      {
        path: 'termination',
        name: 'Termination',
        component: Termination,
        meta: {
          requiresAuth: true,
          title: 'Расторжение',
          roles: permission.groupTermination()
        }
      },
      // {
      //   path: 'rewrite',
      //   name: 'Rewrite',
      //   component: Rewrite,
      //   meta: {
      //     requiresAuth: true,
      //     title: 'Переоформление',
      //     roles: permission.groupRewrite()
      //   }
      // },
      {
        path: 'instruction',
        name: 'Instruction',
        component: Instruction,
        meta: {
          requiresAuth: true,
          title: 'Инструкция',
          roles: permission.all()
        }
      },
      {
        path: 'ogpo',
        name: 'Ogpo',
        component: Ogpo,
        props: true,
        meta: {
          requiresAuth: true,
          title: 'ОГПО ВТС',
          roles: permission.groupReserveSale()
        }
      },
      {
        path: 'bpm-ogpo',
        name: 'BpmOgpo',
        component: BpmOgpo,
        props: true,
        meta: {
          requiresAuth: true,
          title: 'ОГПО ВТС',
          roles: BpmOsgpoModule.Validator.allowedRoles()
        }
      },
      // Financial Institutions
      {
        path: '/financial-institutions',
        meta: {
          roles: permission.groupMainSale()
        },
        children: [
          {
            path: 'properties',
            name: 'Properties',
            component: Properties,
            props: true,
            meta: {
              requiresAuth: true,
              title: 'Имущество',
            },
            roles: permission.groupMainSale()
          },
          {
            path: 'casco',
            name: 'Casco',
            component: Casco,
            props: true,
            meta: {
              requiresAuth: true,
              title: 'Каско',
            },
            roles: permission.groupMainSale()
          }
        ]
      },
      {
        path: 'drafts',
        name: 'Drafts',
        component: Drafts,
        meta: {
          requiresAuth: true,
          title: 'Черновики',
          roles: permission.groupSale()
        }
      },
      {
        path: 'podfts',
        name: 'Podft',
        component: Podft,
        meta: {
          requiresAuth: true,
          title: 'ПОДФТ',
          roles: permission.drm()
        }
      },
      {
        path: 'policies',
        name: 'Policies',
        component: Policies,
        meta: {
          requiresAuth: true,
          title: 'Договоры',
          roles: [...permission.groupSale(),...permission.accountant()]
        }
      },
      {
        path: 'branches',
        name: 'Branches',
        component: Branches,
        meta: {
          requiresAuth: true,
          title: 'Сотрудники',
          roles: [...permission.groupSale(), ...permission.moderator(), ...permission.accountant()]
        }
      },
      {
        path: 'terminals',
        name: 'terminals',
        component: Terminals,
        meta: {
          requiresAuth: true,
          title: 'Терминалы',
          roles: permission.accountant()
        }
      },
      //   Admin
      {
        path: '/admin',
        meta: {
          roles: permission.admin()
        },
        children: [
          {
            path: 'products',
            name: 'Products',
            component: Products,
            meta: {
              requiresAuth: true,
              title: 'Продукты',
            }
          },
          {
            path: 'versions',
            name: 'Versions',
            component: Versions,
            meta: {
              requiresAuth: true,
              title: 'Версии',
            }
          },
          {
            path: 'agreement',
            name: 'Agreement',
            component: Agreement,
            meta: {
              requiresAuth: true,
              title: 'На согласование',
            }
          }
        ]
      },
      //   Support
      {
        path: '/support',
        meta: {
          roles: permission.support()
        },
        children: [
          {
            path: 'operator-error',
            name: 'OperatorError',
            component: OperatorError,
            meta: {
              requiresAuth: true,
              title: 'Ошибки оператора',
            }
          }
        ]
      },
      //   Profile
      {
        path: '/profile',
        component: ProfileLayout,
        meta: {
          roles: permission.all(),
          title: 'Профиль',
        },
        children: [
          {
            path: 'index',
            name: 'Profile',
            component: Profile,
            meta: {
              requiresAuth: true,
            }
          },
          {
            path: 'avr',
            name: 'AVR',
            component: AVR,
            meta: {
              requiresAuth: true,
            }
          },
        ]
      },
      {
        path: "not-found",
        component: PageNotFound,
        meta: {
          requiresAuth: true,
          title: 'Страница не найдено',
          roles: permission.all()
        }
      },
      {
        path: "/:notFound",
        component: PageNotFound,
        redirect: 'not-found',
        meta: {
          requiresAuth: true,
          title: 'Страница не найдено',
          roles: permission.all()
        }
      },
      {
        path: "/:pathMatch(.*)*",
        component: PageNotFound,
        redirect: 'not-found',
        meta: {
          requiresAuth: true,
          title: 'Страница не найдено',
          roles: permission.all()
        }
      }
    ]
  },
  //   Auth
  {
    path: '',
    component: AuthLayout,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: {
          requiresAuth: false,
          title: 'Вход'
        }
      },
      {
        path: 'reset',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
          requiresAuth: false,
          title: 'Сброс пароля'
        }
      },
    ]
  },
  {
    path: '/epay/:id',
    name: 'EpayPayment',
    component: EpayPayment,
    meta: {
      requiresAuth: false,
      title: 'Оплата'
    }
  },
  {
    path: '/kdp/:iin',
    name: 'KdpAgree',
    component: KdpAgree,
    meta: {
      requiresAuth: false,
      title: 'КДП'
    }
  },
  {
    path: '/func/otp/:ulid',
    name: 'FunctionalOTPAgree',
    component: FunctionalOTPAgree,
    meta: {
      requiresAuth: false,
      title: 'OTP'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
})

router.beforeEach((to, from, next) => {
  const access = localStorage.getItem('access')
  if (to.name === 'Login' && access) next({ name: 'Index' })
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!access) {
      next({name: 'Login'})
    } else {
      if (to.matched.some(record => record.meta.roles)) {
        const role = JSON.parse(crypto.decrypt(localStorage.getItem('user'))).role
        if (to.meta.roles.includes(role)) {
          next()
        } else {
          next({path: 'not-found', component: PageNotFound})
        }
      }
    }
  } else {
    next()
  }
})

export default router
